import type { OnDestroy, OnInit } from '@angular/core';
import { Directive, EventEmitter, Output } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[ngTemplateLifecycle]',
})
export class NgTemplateLifecycleDirective implements OnInit, OnDestroy {
  @Output() public ngInit = new EventEmitter<void>();
  @Output() public ngDestroy = new EventEmitter<void>();

  public ngOnInit() {
    this.ngInit.next();
  }

  public ngOnDestroy() {
    this.ngDestroy.next();
  }
}
